import ReportsSerializer from './base';

export default class RubricCriteria extends ReportsSerializer {}
